import React, { PropsWithChildren } from 'react'

export const Column: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex flex-auto min-h-full flex-col h-auto lg:flex-row flex-grow w-full">
      {children}
    </div>
  )
}
